import { useEffect } from "react";

import analytics from "utility/segment";
import { FOTS } from "utility/typescript";

// -----------------------------------------------------------------------------

export default function useAnalytics(pageTitle: string, data: any = undefined) {
  useEffect(() => {
    analytics.page(pageTitle as FOTS, data);
  }, [pageTitle, data]);
}
